import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import config from 'src/config';

const APACSectionStyle = withTheme(styled.div`
  padding: 60px 0px;
  background-image: url('${config.IMAGE_CDN_HOST}/assets/b2b-landing/apac-bg.png');
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;


  .title {
    font-size: 70px;
    font-weight: bold;
    color: ${(props: any) => props.theme.palette.primary.dark};
  }

  .subtitle {
    font-size: 53px;
    color: ${(props: any) => props.theme.palette.primary.dark};
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .title {
      font-size: 48px;
    }
    .subtitle {
      font-size: 36px;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .title {
      font-size: 36px;
    }
    .subtitle {
      font-size: 24px;
    }
  }
`);

export default APACSectionStyle;
